/**
 * Entity choice block renderer.
 */

import { t } from '../../../../i18n.js';

/**
 * @param {Object} block
 * @param {Object} options
 * @param {boolean} [options.resolved]
 * @param {function(string): void} [options.onSelect]
 * @returns {HTMLElement}
 */
export function createEntityChoice(block, { resolved = false, onSelect } = {}) {
  const { prompt, options: choiceOptions } = block;
  const isDisabled = resolved || !onSelect;

  const container = document.createElement('div');
  container.className = `ai-entity-choice${resolved ? ' ai-entity-choice--resolved' : ''}`;
  container.setAttribute('role', 'group');
  container.setAttribute('aria-label', prompt || 'Choose an option');

  if (prompt) {
    const promptEl = document.createElement('p');
    promptEl.className = 'ai-entity-choice__prompt';
    promptEl.textContent = prompt;
    container.appendChild(promptEl);
  }

  const optionsWrap = document.createElement('div');
  optionsWrap.className = 'ai-entity-choice__options';

  (choiceOptions || []).forEach((option) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ai-entity-choice__option';
    btn.textContent = option.label;

    if (isDisabled) {
      btn.setAttribute('aria-disabled', 'true');
      btn.tabIndex = 0;
    } else {
      btn.addEventListener('click', () => {
        onSelect(option.value ?? option.label, option.label);
      });
    }

    optionsWrap.appendChild(btn);
  });

  container.appendChild(optionsWrap);

  if (!resolved) {
    const hint = document.createElement('p');
    hint.className = 'ai-entity-choice__hint';
    hint.textContent = t('ai_choice_free_text_hint');
    container.appendChild(hint);
  }

  return container;
}
